import useProviders from './useProviders';

export default function useProvider({ instId }: { instId: string }) {
    const { data: providers } = useProviders();
    return providers?.find(provider => provider.institutionId === instId);
}
